// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"3c0ba194","239":"2729cb2c","335":"a9b1c36a","361":"6c3e9a30","453":"a22cc8a0","455":"62523b48","460":"8ae3e052","552":"f8c36920","772":"7731cf38","926":"52842d3d","944":"c7f1fceb","977":"c3511c31"}[chunkId] + ".chunk.js";
};